import React, { useState, useEffect, useMemo } from "react";
import Select from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
// import {  Modal } from 'antd';
import FilterSelect from "components/Form/filterSelect";
import * as Yup from "yup";
import { Link } from "react-router-dom";

import { yupResolver } from "@hookform/resolvers/yup";
import { useForm, Controller, useFieldArray } from "react-hook-form";
import {
  customStyleSelect,
  formatDateHandler,
  formatDateHandler2,
  toTitleCase,
} from "utils/common";
import useUploadHook from "components/uploadHook";
import {
  getExpenseApi,
  postExpensesApi,
  getExpenseType,
  updateExpensesApi,
} from "api/services/expense";
import { toast, Bounce } from "react-toastify";
import { format } from "date-fns";
import { Button } from "components/Button";
import { useSelector } from "react-redux";
import { leaveStatusOptions } from "utils/constants";
import EssFullWidthModal from "components/modelpopup/baseModal";
import { Steps } from "antd";
import { FaCheckCircle } from "react-icons/fa";
import { MdPending } from "react-icons/md";
import { MdOutlineError } from "react-icons/md";
import { FaTimesCircle } from "react-icons/fa";

import Attachments from "components/Attachments/attachmentListEdit";
import AttachmentThumb from "components/Attachments/attachmentThumbEdit";
import { FaSpinner } from "react-icons/fa"; // Import a spinner icon
import { useMediaQuery } from "react-responsive";
import { useDropzone } from 'react-dropzone';
import DateInput from "components/Form/dateInput";

const ExpenseCreateModal = (props) => {
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });

  const expenseApprovalSchema = Yup.object().shape({
    approval_status: Yup.object().required("Status is required"),
    // description: Yup.string(),

    // comments: Yup.string().test(
    //   'is-required-when-rejected',
    //   'Comments are required when the status is rejected',
    //   function (value) {
    //     const { approval_status } = this.parent; // Access the parent object
    //     return approval_status?.value !== 'rejected' || (value && value.trim().length > 0);
    //   }
    // ),
  });

  const expenseSchema = Yup.object().shape({
    company_user: Yup.object().required("user is required"),
    // claim_no: Yup.string().required("Claim number is required"),
    reference_date: Yup.string().required("Request date is required"),
    cost_center: Yup.object().required("Cost center is required"),
    // posting_date: Yup.string().required("Posting date is required"),
    // description: Yup.string(),
  });
  const [loading, setLoading] = useState(false);
  const [userOption, setUserOption] = useState([]);
  const [numberOfDays, setNumberOfDays] = useState(5);
  const [expenseBalance, setLeaveBalance] = useState(0);
  const [roleDelegationEnabled, setDelegationEnabled] = useState(false);
  const [roleDelegationOptions, setDelegationOptions] = useState([]);
  const [roleDelegationLoading, setDelegationLoading] = useState(false);
  const [statusOptions, setStatusOptions] = useState([]);

  const [selectedExpense, setSelectedExpense] = useState("");

  const [currentStatusStep, setCurrentStatusStep] = useState(0);
  const [statusSteps, setStatusSteps] = useState([]);
  const [expenseTypeOptions, setExpenseTypeOptions] = useState([]);
  const [costCenterOptions, setCostCenterOptions] = useState([]);

  // const statusOptions = [
  //   {label:"Approved", value: "approved"},
  //   {label:"Rejected", value: "rejected"}
  // ]
  const { uploadLoading, handleFile } = useUploadHook();
  const { userData, userDataLoading, costCenter, costCenterLoading } = useSelector((state) => state.common);
  const { user, userLoading } = useSelector((state) => state.user);

  const [totals, setTotals] = useState({});

  const {
    control,
    handleSubmit,
    formState: { errors },
    getValues,
    watch,
    setValue,
    setError,
    reset,
    register,
  } = useForm({
    resolver: yupResolver(expenseSchema),
    defaultValues: {
      company_user: {},
      //   posting_date: new Date(),
      reference_date: new Date(),
      attachments: [],
      expense_claim_detail: [],
    },
  });

  const {
    control: statusControl,
    handleSubmit: handleStatusSubmit,
    formState: { errors: statusError },
    setValue: setStatusValue,
    reset: statusReset,
    setError: setStatusError,
    trigger,
  } = useForm({
    resolver: yupResolver(expenseApprovalSchema),
    defaultValues: {},
  });


  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const { fields, remove } = useFieldArray({
    control, // control props comes from useForm (optional: if you are using FormProvider)
    name: "attachments", // unique name for your Field Array
  });

  const {
    fields: expenseField,
    append,
    prepend,
    remove: expenseRemove,
    swap,
    move,
    insert,
  } = useFieldArray({
    control, // control props comes from useForm (optional: if you are using FormProvider)
    name: "expense_claim_detail", // unique name for your Field Array
  });

  const createApprovalSteps = () => {
    let generated_steps = [];
    let current_step = selectedExpense?.approval_level;
    let existing_steps = selectedExpense?.expense_approval;

    if (selectedExpense?.approval_status == "cancelled") {
      generated_steps.push({
        title: "Request",
        subTitle: "Cancelled",
        description: <span className="text-wrap lh-1 text-dark" style={{fontSize:9}}>{`${formatDateHandler2(
          selectedExpense?.created_at
        )} by ${selectedExpense?.company_user?.first_name} ${
          selectedExpense?.company_user?.last_name
        }`}</span>,
        icon: <FaTimesCircle color="red" size={35} />,
      });
    } else {
      generated_steps.push({
        title: "Request",
        subTitle: "Created",
        description: <span className="text-wrap lh-1 text-dark" style={{fontSize:9}}>{`${formatDateHandler2(
          selectedExpense?.created_at
        )}  by ${selectedExpense?.company_user?.first_name} ${
          selectedExpense?.company_user?.last_name
        }`}</span>,
        icon: <FaCheckCircle color="green" size={35} />,
      });
    }
    existing_steps.forEach((item) => {
      generated_steps.push({
        title: "Approval",
        subTitle: toTitleCase(item?.status),
        description: <span className="text-wrap lh-1 text-dark" style={{fontSize:9}}>{`${
          item?.status == "pending"
            ? item.approver?.first_name + " " + item.approver?.last_name
            : toTitleCase(item.status) +
              " on " +
              formatDateHandler2(item?.approved_on) +
              " by " +
              item.approver?.first_name +
              " " +
              item.approver?.last_name
        } ${item?.comment ? "| Comment: " + item?.comment : ''}`}</span>,
        icon:
          item?.status == "pending" ? (
            <MdPending size={35} />
          ) : item?.status == "rejected" ? (
            <FaTimesCircle color="red" size={35} />
          ) : (
            <FaCheckCircle color="green" size={35} />
          ),
      });
    });
    setCurrentStatusStep(current_step);
    setStatusSteps(generated_steps);
 
  };
  useEffect(() => {
    if (selectedExpense) {
      createApprovalSteps()
      console.log(user, selectedExpense.company_user, "UUUUU");
      if (
        user.id == selectedExpense.company_user?.id &&
        selectedExpense?.approval_status == "pending"
      ) {
        setStatusOptions(
          leaveStatusOptions.filter((item) => item.value == "cancelled")
        );
      }

      if (
        user.id == selectedExpense.current_approver?.id &&
        selectedExpense?.approval_status == "pending"
      ) {
        setStatusOptions(
          leaveStatusOptions.filter((item) => item.value != "cancelled")
        );
      }

      //   createApprovalSteps();
    } else {
      setStatusOptions([]);
    }
  }, [selectedExpense]);

  useEffect(() => {
    if (props.expenseData && props.expenseModal) {
      getExpenseApi(props.expenseData?.id).then((response) => {
        console.log(response.data, "LLLL");
        setSelectedExpense(response?.data);
      });
    }
  }, [props.expenseData]);

  useEffect(() => {
    console.log("2222");
    if (!expenseTypeOptions.length) {
      getExpenseType().then((res) => {
        console.log(res.data);

        let expense_options = [...res.data.results].map((item) => {
          return {
            label: item.name,
            value: item.id,
          };
        });
        setExpenseTypeOptions(expense_options);
      });
    }
  }, []);

  useEffect(() => {
    if (costCenter) {
      setCostCenterOptions(costCenter.map(item => ({
        label: item.name,
        value: item.id
      })));
    }
  }, [costCenter]);

  useEffect(() => {
    if (selectedExpense?.id && userOption.length && expenseTypeOptions.length) {
      console.log(selectedExpense?.id , userOption.length , expenseTypeOptions.length , "HHHHH");
      let user = userOption.find(
        (item) => item.value == selectedExpense?.company_user?.id
      );
      setValue("company_user", user || "");
      //   setValue("claim_no", selectedExpense?.claim_no || "");
      setValue("reference_date", selectedExpense?.reference_date || "");
      
      // Set cost center value
      if (selectedExpense?.cost_center) {
        let costCenter = costCenterOptions.find(item => item.value == selectedExpense?.cost_center?.id);
        setValue("cost_center", costCenter || "");
      }
      //   setValue("posting_date", selectedExpense?.posting_date || "");
      //   setValue("description", selectedExpense?.description || "");

      let claim_detail = selectedExpense?.expense_claim_detail.map((item) => {
        let expense_type_selected = expenseTypeOptions.find(
          (ex_item) => ex_item.value == item.expense_type?.id
        );
        return {
          ...item,
          expense_type: expenseTypeOptions.find(
            (ex_item) => ex_item.value == item.expense_type?.id
          ),
          attachments: item?.attachments?.map((item) => {
            return {
              // id: item.id,
              item_id: item.id,
              url: item.url,
            };
          }),
        };
      });
      setValue("expense_claim_detail", claim_detail || []);
      setValue(
        "attachments",
        selectedExpense?.attachments?.map((item) => {
          return {
            // id: item.id,
            item_id: item.id,
            url: item.url,
          };
        })
      );
      // let approvalStatus = leaveStatusOptions.find(item=> item.value == selectedExpense.approval_status)
      // console.log(approvalStatus, leaveStatusOptions,selectedExpense.approval_status, "JJJJ")
      // setStatusValue("approval_status", approvalStatus)
    } else {
      console.log("HITTTTTTTTTTTTTTTTTTTTTTTTTTTTT")
      reset();
      statusReset();
      //   setValue("attachments", [])
      //   trigger()

      let selectedUserOption = userOption.find(
        (item) => item.value == user?.id
      );
      if (selectedUserOption) {
        setValue("company_user", selectedUserOption);
      }
    }
  }, [selectedExpense, userOption, expenseTypeOptions, costCenterOptions, props.expenseModal]);

  useEffect(() => {
    let access_scope = "all"; //props.user.role.access_scope;
    if (userData && props.user) {
      let users = [];

      if (access_scope === "all" || access_scope === "hierarchy") {
        users = userData.map((item) => ({
          label: `${item.first_name} ${item.last_name}`,
          value: item.id,
        }));
      } else if (access_scope === "self") {
        users = userData
          .filter((item) => item.id === props.user.id) // Restrict to logged-in user
          .map((item) => ({
            label: `${item.first_name} ${item.last_name}`,
            value: item.id,
          }));
      }

      setUserOption(users);
    }

    // if(userData){
    //   let users = userData.map(item=> {
    //     return{
    //         label: `${item.first_name} ${item.last_name}`,
    //         value: item.id
    //     }
    // })
    //   setUserOption(users)
    // }
  }, [userData, props.expenseModal]);

  useEffect(() => {
    if (userOption.length) {
      if (userOption.length === 1) {
        console.log("&&&&&&&&&&&&&&&&&", userOption[0]);
        setValue("company_user", userOption[0]);
      }
    }
  }, [userOption, selectedExpense, props.expenseModal]);
  const fileUploadHandler = async (acceptedFiles , rejectedFiles , e ) => {
    console.log(e.target.files, "EEEE");
    let attachments = [];
    const urls = await handleFile(e);
    if (Array.isArray(urls)) {
      attachments = urls.map((item) => {
        return { url: item };
      });
    } else {
      attachments.push({
        url: urls,
      });
    }
    console.log(fields, "LLLL");

    setValue("attachments", [...fields, ...attachments]);
  };

  const detailFileUploadHandler = async (e, index) => {
    console.log(e.target.files, "EEEE");
    let attachments = [];
    const urls = await handleFile(e);
    if (Array.isArray(urls)) {
      attachments = urls.map((item) => {
        return { url: item };
      });
    } else {
      attachments.push({
        url: urls,
      });
    }

    console.log(expenseField[index].attachments, attachments, "DDDDDDD");

    setValue(`expense_claim_detail.${index}.attachments`, [
      ...expenseField[index].attachments,
      ...attachments,
    ]);
    trigger(`expense_claim_detail.${index}.attachments`); // Ensure re-render

    // console.log(fields, "LLLL");

    // setValue("attachments", [...fields, ...attachments]);
  };

  const onStatusChange = (data) => {
    setLoading(true);

    console.log(data, "LLLLL");
    data["approval_status"] = data?.approval_status?.value;
    // statusChangeLeaveApi(data, selectedExpense?.id)
    //   .then((response) => {
    //     setLoading(false);

    //     toast.success("Leave status updated!", {
    //       position: "top-right",
    //       autoClose: 5000,
    //       hideProgressBar: false,
    //       closeOnClick: false,
    //       pauseOnHover: true,
    //       draggable: true,
    //       progress: undefined,
    //       theme: "light",
    //       transition: Bounce,
    //     });
    //     props.setExpenseModal(false);
    //     props.setSelectedExpense("");
    //     reset();
    //     props.fetchLeaveList();

    //     console.log(response, "REEEEEE");
    //   })
    //   .catch((e) => {
    //     console.log(e, "eee");
    //     try {
    //       console.log(e.response.data, "EEEEE");
    //       // let response = e.response?.data?.error || "Error updating expense status!"
    //       setLoading(false);
    //       // toast.error(response, {
    //       //   position: "top-right",
    //       //   autoClose: 5000,
    //       //   hideProgressBar: false,
    //       //   closeOnClick: false,
    //       //   pauseOnHover: true,
    //       //   draggable: true,
    //       //   progress: undefined,
    //       //   theme: "light",
    //       //   transition: Bounce,
    //       //   });

    //       if (e.response.data) {
    //         Object.entries(e.response.data).forEach(([k, v]) => {
    //           console.log(typeof v, k, "EEEEE");
    //           setStatusError(k, {
    //             type: "manual",
    //             message: v.join(", "),
    //           });
    //         });
    //       }
    //     } catch (err) {
    //       console.log(err, "LLLLLLL");
    //       let response =
    //         e.response?.data?.error || "Error updating expense status!";
    //       setLoading(false);
    //       toast.error(response, {
    //         position: "top-right",
    //         autoClose: 5000,
    //         hideProgressBar: false,
    //         closeOnClick: false,
    //         pauseOnHover: true,
    //         draggable: true,
    //         progress: undefined,
    //         theme: "light",
    //         transition: Bounce,
    //       });
    //     }
    //   });
  };
  const onSubmit = (data) => {
    console.log(data, "LLLLL");
    setLoading(true);
    // data["expense_type"] = data?.expense_type?.value;
    data["company_user"] = data?.company_user?.value;
    data["cost_center"] = data?.cost_center?.value;
    // data["company_user"] = data?.company_user?.value;

    // let attachments_data = data["attachments"]?.map((item) => {
    //   return item.url;
    // });
    // data["attachments"] = attachments_data;

    // reset()
    // data['department'] = data?.department?.value
    // data['status'] = data?.status?.value
    if (data.reference_date) {
      data["reference_date"] = format(
        new Date(data.reference_date),
        "yyyy-MM-dd"
      );
    }
    // if (data.posting_date) {
    //     data["posting_date"] = format(new Date(data.posting_date), "yyyy-MM-dd");
    //   }

    let details = data.expense_claim_detail?.map((item) => {
      return {
        ...item,
        posting_date: item?.posting_date
          ? format(new Date(item.posting_date), "yyyy-MM-dd")
          : "",
        expense_type: item?.expense_type?.value || "",

        attachments: item?.attachments?.map((item) => {
          return {
            id: item.item_id || "",
            url: item.url,
          };
        }),
      };
    });

    let attachments_data = data["attachments"].map((item) => {
      return {
        id: item.item_id || "",
        url: item.url,
      };
    });
    data["attachments"] = attachments_data;

    data.expense_claim_detail = details;

    //(expenseBalance > numberOfDays) validate if balance expense is available to apply

    if (selectedExpense?.id) {
      updateExpensesApi(selectedExpense?.id, data)
        .then((response) => {
          setLoading(false);

          toast.success("Expense Updated!", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            transition: Bounce,
          });
          props.setExpenseModal(false);

          props.fetchExpenseList();
          reset();
          statusReset();

          console.log(response, "REEEEEE");
        })
        .catch((e) => {
          console.log(e, "eee");
          setLoading(false);
          try {
            console.log(e.response.data, "EEEEE");
            if (e.response.data) {
              if (
                e.response.data?.expense_amount ||
                e.response.data?.expense_type ||
                e.response.data?.posting_date
              ) {
                // `Expense Amount: ${e.response.data?.expense_amount}, Expense type: ${e.response.data?.expense_type}, Posting Date: ${e.response.data?.posting_date}`
                let m =
                  "Expense Amount, Expense Type and posting Date are required";
                toast.error(m, {
                  position: "top-right",
                  autoClose: 5000,
                  hideProgressBar: false,
                  closeOnClick: false,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                  theme: "light",
                  transition: Bounce,
                });
              }
              Object.entries(e.response.data).forEach(([k, v]) => {
                console.log(typeof v, "EEEEE");
                setError(k, {
                  type: "manual",
                  message: v.join(", "),
                });
              });
            }
          } catch (e) {
            toast.error("Failed to update expense!", {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: false,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
              transition: Bounce,
            });
          }
        });
    } else {
      postExpensesApi(data)
        .then((response) => {
          setLoading(false);

          toast.success("Expense Created!", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            transition: Bounce,
          });
          props.setExpenseModal(false);

          props.fetchExpenseList();
          reset();

          console.log(response, "REEEEEE");
        })
        .catch((e) => {
          console.log(e, "eee");
          setLoading(false);
          try {
            console.log(e.response.data, "EEEEE");
            if (e.response.data) {
              if (
                e.response.data?.expense_amount ||
                e.response.data?.expense_type ||
                e.response.data?.posting_date
              ) {
                // `Expense Amount: ${e.response.data?.expense_amount}, Expense type: ${e.response.data?.expense_type}, Posting Date: ${e.response.data?.posting_date}`
                let m =
                  "Expense Amount, Expense Type and posting Date are required";
                toast.error(m, {
                  position: "top-right",
                  autoClose: 5000,
                  hideProgressBar: false,
                  closeOnClick: false,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                  theme: "light",
                  transition: Bounce,
                });
              }
              Object.entries(e.response.data).forEach(([k, v]) => {
                console.log(typeof v, "EEEEE");
                setError(k, {
                  type: "manual",
                  message: v.join(", "),
                });
              });
            }
          } catch (e) {
            toast.error("Failed to create expense!", {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: false,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
              transition: Bounce,
            });
          }
        });
    }
  };

  const expenses = watch("expense_claim_detail") || [];

  const removeAttachment = (expenseIndex, indexToRemove) => {
    console.log(expenseIndex, indexToRemove, "KKKK");

    let attachments = expenses[expenseIndex].attachments;
    attachments = attachments.filter((_, index) => index !== indexToRemove);
    console.log(attachments, "KKKKKKK");

    setValue(`expense_claim_detail.${expenseIndex}.attachments`, attachments);
    trigger(`expense_claim_detail.${expenseIndex}.attachments`); // Ensure re-render
  };
  const changeTotal = () => {
    console.log(expenses, "KKKKKKK");
    let totals = expenses?.reduce(
      (totals, item) => {
        totals.expense_amount += Number(item.expense_amount) || 0;
        totals.expense_approved_amount +=
          Number(item.expense_approved_amount) || 0;
        return totals;
      },
      { expense_amount: 0, expense_approved_amount: 0 }
    );
    setTotals(totals);
  };

  // ✅ useMemo for efficient total calculation
  const totalAmounts = useMemo(() => {
    console.log("HEREEEEE");
    if (props.expenseModal) {
      return changeTotal();
    }
  }, [expenses, props?.expenseModal]); // Recalculates only when `expenses` change

  // ✅ Update total onBlur instead of on every keystroke
  const handleBlur = () => {
    console.log("JJJJJ");
    return changeTotal();
  };

  // Use Dropzone hook
  const { getRootProps, getInputProps } = useDropzone({
    onDrop: fileUploadHandler,
    multiple:true,

    accept: 'image/*', // Accept image, PDF, DOCX
  });


  return (
    <>
      <EssFullWidthModal
        mask={false}
        title={selectedExpense ? "Update expense" : "Create Expense"}
        // style={{ top: 100 }}
        open={props.expenseModal}
        width={"40%"}
        footer={[]}
        onCancel={() => {
          console.log("CLOSEEEEEEEEEEEE")
          reset({
            company_user: {},
            reference_date: new Date(),
            attachments: [],
            expense_claim_detail: [],
          });
          // reset();
          statusReset({});
          setDelegationEnabled(false);

          props?.setExpenseData("");
          console.log("CLOSEEEEEEEEEEEE")
          props.setExpenseModal(false);
          setSelectedExpense("");
          setLoading(false);
        }}
        className="full-width-modal"
      >
        <div className="modal-content">
          <div className="modal-body">
            <form onSubmit={handleSubmit(onSubmit)}>
            <div className="row" >
                  
                  <div className="col-md-12 col-sm-12" >
                    <div className="card p-3" >
                    <label className="col-form-label">
                      Approval status
                    </label>

                    <Steps
                    current={currentStatusStep}
                    // percent={60}
                    items={statusSteps}
                  />
                    </div>
                 
                  </div>
                </div>
                <br />
              <div className="row">
                <div className="input-block mb-3 col-md-6 col-sm-12">
                  <label className="col-form-label">
                    User <span className="text-danger">*</span>
                  </label>

                  <Controller
                    name={`company_user`}
                    // name={"assignee"}
                    control={control}
                    // defaultValue=""
                    // rules={{ required: 'Select a contact' }}
                    render={({ field }) => (
                      <>
                        <FilterSelect
                          // className={"w-50"}
                          isDisabled={
                            userOption.length == 1 ||
                            (selectedExpense &&
                              selectedExpense?.approval_status !== "pending")
                          }
                          isClearable={true}
                          onChange={(e) => {
                            field.onChange(e);
                          }}
                          optionLabel={"label"}
                          optionValue={"value"}
                          options={userOption}
                          defaultValue={userOption[0]}
                          value={field.value}
                          placeholder={"Select user"}
                          styles={customStyleSelect}
                          isLoading={userDataLoading}
                        />
                      </>
                    )}
                  />
                  {errors.company_user && (
                    <small className="text-danger">
                      {errors.company_user?.message}
                    </small>
                  )}
                </div>

                <div className="input-block mb-3 col-md-6 col-sm-12">
                  <label className="col-form-label">
                    Request date <span className="text-danger">*</span>
                  </label>
               
                    <Controller
                      name="reference_date"
                      control={control}
                      // rules={{ required: 'File name is required' }}
                      render={({ field }) => (
                        <DateInput
                          disabled={
                            selectedExpense &&
                            selectedExpense?.approval_status !== "pending"
                          }
                          className="form-control floating datetimepicker "
                          selected={field?.value ?? new Date()}
                          onChange={(date) => {
                            field.onChange(date);
                          }}
                          dateFormat="dd-MM-yyyy"
                          // minDate={new Date()}
                        />
                      )}
                    />

                    {errors.reference_date && (
                      <small className="text-danger">
                        {errors.reference_date?.message}
                      </small>
                    )}
                 
                </div>
              </div>

              <div className="row">
                <div className="input-block mb-3 col-md-6 col-sm-12">
                  <label className="col-form-label">
                    Cost Center <span className="text-danger">*</span>
                  </label>

                  <Controller
                    name={`cost_center`}
                    control={control}
                    render={({ field }) => (
                      <>
                        <FilterSelect
                          isDisabled={
                            selectedExpense &&
                            selectedExpense?.approval_status !== "pending"
                          }
                          isClearable={true}
                          onChange={(e) => {
                            field.onChange(e);
                          }}
                          optionLabel={"label"}
                          optionValue={"value"}
                          options={costCenterOptions}
                          value={field.value}
                          placeholder={"Select cost center"}
                          styles={customStyleSelect}
                          isLoading={costCenterLoading}
                        />
                      </>
                    )}
                  />
                  {errors.cost_center && (
                    <small className="text-danger">
                      {errors.cost_center?.message}
                    </small>
                  )}
                </div>
              </div>

              <div className="row">
                {/* <div className="input-block mb-3 col-md-6 col-sm-12">
                    <label className="col-form-label">
                    Posting date <span className="text-danger">*</span>
                    </label>
                    <div className="cal-icon">
                      <Controller
                        name="posting_date"
                        control={control}
                        // rules={{ required: 'File name is required' }}
                        render={({ field }) => (
                          <DatePicker
                          disabled={selectedExpense && selectedExpense?.approval_status !=="pending"}
                            className="form-control floating datetimepicker "
                            selected={field?.value}
                            onChange={(date) => {
                              
                              field.onChange(date);
                          
                            }}
                            dateFormat="dd-MM-yyyy"
                            // minDate={new Date()}
                          />
                        )}
                      />

                      {errors.posting_date && (
                        <small className="text-danger">
                          {errors.posting_date?.message}
                        </small>
                      )}
                    </div>
                  </div> */}
                {/* <div className="input-block mb-3 col-md-6 col-sm-12">
                    <label className="col-form-label">
                      Claim No <span className="text-danger">*</span>
                    </label>

                    <Controller
                      name="claim_no"
                      control={control}
                      // rules={{ required: 'File name is required' }}
                      render={({ field }) => (
                        <textarea
                        disabled={selectedExpense && selectedExpense?.approval_status !=="pending"}
                          rows={1}
                          className="form-control"
                          value={field?.value}
                          onChange={field?.onChange}
                        />
                      )}
                    />
                    {errors.claim_no && (
                      <small className="text-danger">
                        {errors.claim_no?.message}
                      </small>
                    )}
                    </div> */}
              </div>

              {/* <div className="row" >
                <div className="input-block mb-3 col-md-6 col-sm-12">
                    <label className="col-form-label">
                    Description <span className="text-danger">*</span>
                    </label>
                    
                    <Controller
                      name="description"
                      disabled={selectedExpense && selectedExpense?.approval_status !=="pending"}
                      control={control}
                      // rules={{ required: 'File name is required' }}
                      render={({ field }) => (
                        <textarea
                          rows={4}
                          className="form-control"
                          value={field?.value}
                          onChange={field?.onChange}
                        />
                      )}
                    />
                    {statusError.description && (
                      <small className="text-danger">
                        {statusError.description?.message}
                      </small>
                    )}
                    
                  </div>
                   </div>
                 */}
                 {
                  isMobile  ?
                  <div className="row expense-modal-table-mobile">
                    <div className="col-md-12 col-sm-12">
                      {
                        !selectedExpense.id && ( // requested to remove add expense on edit page on 3-oct-2025
                          <Link
                          to="#"
                          className=" btn btn-danger mb-2"
                          title="Add"
                          id="addProduct"
                          onClick={() => {
                            append({
                              expense_type: "",
                              expense_amount: "",
                              posting_date: "",
                              description: "",
                              expense_approved_amount: "",
                              attachments: [],
                            });
                          }}
                        >
                          <i className="fa-solid fa-plus" />
                        </Link>
                        )
                      }
                

                {
                expenseField.map((row, expenseIndex) => (
                  <div  key={row.id} className="card p-3">
                    <div className="row">
                      {/* Type */}
                      <div className="col-6 mb-3">
                        <label className="form-label">Type</label>
                        <Controller
                                  name={`expense_claim_detail.${expenseIndex}.expense_type`}
                                  // name={"assignee"}
                                  control={control}
                                  // defaultValue=""
                                  // rules={{ required: 'Select a contact' }}
                                  render={({ field }) => (
                                    <>
                                      <FilterSelect
                                        isDisabled={
                                          selectedExpense &&
                                          selectedExpense?.approval_status !==
                                            "pending"
                                        }
                                        // isClearable={true}
                                        onChange={(e) => {
                                          field.onChange(e);
                                        }}
                                        optionLabel={"label"}
                                        optionValue={"value"}
                                        options={expenseTypeOptions}
                                        value={field.value}
                                        placeholder={"Charge type"}
                                        styles={customStyleSelect}
                                        isLoading={false}
                                        menuPlacement="top"
                                      />
                                    </>
                                  )}
                                />
                      
                      </div>

                      {/* Date */}
                      <div className="col-6 mb-3">
                        <label className="form-label">Date</label>
                        <input
                                  disabled={
                                    selectedExpense &&
                                    selectedExpense?.approval_status !==
                                      "pending"
                                  }
                                  {...register(
                                    `expense_claim_detail.${expenseIndex}.posting_date`
                                  )}
                                  type="date"
                                  className="form-control"
                                />
                      </div>
                    </div>

                    <div className="row">
                      {/* Description */}
                      <div className="col-6 mb-3">
                        <label className="form-label">Description</label>
                        <textarea
                                  disabled={
                                    selectedExpense &&
                                    selectedExpense?.approval_status !==
                                      "pending"
                                  }
                                  {...register(
                                    `expense_claim_detail.${expenseIndex}.description`
                                  )}
                                  className="form-control"
                                  rows={1}
                                  placeholder="Description"
                                />
                      </div>

                      {/* Amount */}
                      <div className="col-6  mb-3">
                        <label className="form-label">Amount</label>
                        <input
                                  disabled={
                                    selectedExpense &&
                                    selectedExpense?.approval_status !==
                                      "pending" ||
                                      expenses[expenseIndex]?.expense_approved_amount
                                  }
                                  {...register(
                                    `expense_claim_detail.${expenseIndex}.expense_amount`
                                  )}
                                  type="number"
                                  className="form-control"
                                  placeholder="Amount"
                                  onBlur={handleBlur}
                                  step="0.01"
                                />
                      </div>
                    </div>

                    <div className="row">
                      {/* Approved Amount */}
                      <div className="col-6  mb-3">
                        <label className="form-label">Approved Amount</label>
                        <input
                                  disabled={true}
                                  {...register(
                                    `expense_claim_detail.${expenseIndex}.expense_approved_amount`
                                  )}
                                  type="number"
                                  className="form-control"
                                  placeholder="Amount"
                                />
                      </div>

                      {/* Attachments */}
                      <div className="col-6  mb-3">
                      <label className="form-label">Attachments</label>
                      <div className="input-group">
                      
                                  <input
                                    multiple
                                    type="file"
                                    {...register(
                                      `expense_claim_detail.${expenseIndex}.attachments`
                                    )}
                                    className="form-control"
                                    onChange={(e) =>
                                      detailFileUploadHandler(e, expenseIndex)
                                    }
                                    disabled={
                                      uploadLoading ||
                                      (selectedExpense &&
                                        selectedExpense?.approval_status !==
                                          "pending")
                                    }
                                    id="fileInput"
                                  />

                                  {uploadLoading ? (
                                    <label
                                      className="input-group-text"
                                      htmlFor="fileInput"
                                    >
                                      <i className="fas fa-spinner fa-spin"></i>
                                    </label>
                                  ) : (
                                    ""
                                  )}
                                </div>
                      </div>
                      <div className="col-12 mb-3" >
                      <AttachmentThumb
                                  fields={
                                    expenses &&
                                    expenses[expenseIndex]?.attachments
                                  }
                                  remove={(itemIndex) =>
                                    removeAttachment(expenseIndex, itemIndex)
                                  }
                                />
                      </div>
                    </div>
                    {
                      !expenses[expenseIndex]?.expense_approved_amount && (
                        <Link
                        className="text-danger font-18 remove"
                        title="Remove"
                        onClick={() => {
                          if(!expenses[expenseIndex]?.expense_approved_amount){
                            expenseRemove(expenseIndex)
                          }
                        }}
                      >
                        <i className="fa-regular fa-trash-can" />
                      </Link>
                      )
                    }
                   
                  </div>
                ))}
                  

                    </div>
                </div>
                :
                <div className="row">
                <div className="col-md-12 col-sm-12">
               
                  <div className="table-responsive expense-modal-table-desktop">
                    <table
                      className="table table-hover table-white expense-detail-table"
                      id="addTable"
                    >
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Type</th>
                          <th>Date</th>
                          <th>Description</th>
                          <th>Amount</th>
                          <th>Approved Amount</th>
                          <th>Attachments</th>

                          <th> </th>
                        </tr>
                      </thead>
                      <tbody className="expense-detail-table-body">
                        <tr>
                          {
                            !selectedExpense.id && ( // requested to remove add expense on edit page on 3-oct-2025
                              <td>
                            <Link
                              to="#"
                              className="text-success font-18"
                              title="Add"
                              id="addProduct"
                              onClick={() => {
                                append({
                                  expense_type: "",
                                  expense_amount: "",
                                  posting_date: "",
                                  description: "",
                                  expense_approved_amount: "",
                                  attachments: [],
                                });
                              }}
                            >
                              <i className="fa-solid fa-plus" />
                            </Link>
                          </td>
                            )
                          }
                         
                        </tr>
                        {expenseField.map((row, expenseIndex) => (
                          <>
                            <tr key={row.id}>
                              <td>{expenseIndex + 1}</td>
                              <td>
                                <Controller
                                  name={`expense_claim_detail.${expenseIndex}.expense_type`}
                                  // name={"assignee"}
                                  control={control}
                                  // defaultValue=""
                                  // rules={{ required: 'Select a contact' }}
                                  render={({ field }) => (
                                    <>
                                      <FilterSelect
                                        isDisabled={
                                          selectedExpense &&
                                          selectedExpense?.approval_status !==
                                            "pending"
                                        }
                                        // isClearable={true}
                                        onChange={(e) => {
                                          field.onChange(e);
                                        }}
                                        optionLabel={"label"}
                                        optionValue={"value"}
                                        options={expenseTypeOptions}
                                        value={field.value}
                                        placeholder={"Charge type"}
                                        styles={customStyleSelect}
                                        isLoading={false}
                                        menuPlacement="top"
                                      />
                                    </>
                                  )}
                                />
                              </td>
                              <td>
                                <input
                                  disabled={
                                    selectedExpense &&
                                    selectedExpense?.approval_status !==
                                      "pending"
                                  }
                                  {...register(
                                    `expense_claim_detail.${expenseIndex}.posting_date`
                                  )}
                                  type="date"
                                  className="form-control"
                                />
                              </td>
                              <td>
                                <textarea
                                  disabled={
                                    selectedExpense &&
                                    selectedExpense?.approval_status !==
                                      "pending"
                                  }
                                  {...register(
                                    `expense_claim_detail.${expenseIndex}.description`
                                  )}
                                  className="form-control"
                                  rows={1}
                                  placeholder="Description"
                                />
                              </td>
                              <td>
                                <input
                                  disabled={
                                    selectedExpense &&
                                    selectedExpense?.approval_status !==
                                      "pending" ||
                                      expenses[expenseIndex]?.expense_approved_amount
                                  }
                                  {...register(
                                    `expense_claim_detail.${expenseIndex}.expense_amount`
                                  )}
                                  type="number"
                                  className="form-control"
                                  placeholder="Amount"
                                  onBlur={handleBlur}
                                  step="0.01"
                                />
                              </td>
                              <td>
                                <input
                                  disabled={true}
                                  {...register(
                                    `expense_claim_detail.${expenseIndex}.expense_approved_amount`
                                  )}
                                  type="number"
                                  className="form-control"
                                  placeholder="Amount"
                                />
                              </td>

                              <td>
                                <div className="input-group">
                                  <input
                                    multiple
                                    type="file"
                                    {...register(
                                      `expense_claim_detail.${expenseIndex}.attachments`
                                    )}
                                    className="form-control"
                                    onChange={(e) =>
                                      detailFileUploadHandler(e, expenseIndex)
                                    }
                                    disabled={
                                      uploadLoading ||
                                      (selectedExpense &&
                                        selectedExpense?.approval_status !==
                                          "pending")
                                    }
                                    id="fileInput"
                                  />

                                  {uploadLoading ? (
                                    <label
                                      className="input-group-text"
                                      htmlFor="fileInput"
                                    >
                                      <i className="fas fa-spinner fa-spin"></i>
                                    </label>
                                  ) : (
                                    ""
                                  )}
                                </div>
                              </td>

                              <td>
                                {
                                  !expenses[expenseIndex]?.expense_approved_amount && (
                                    <Link
                                    className="text-danger font-18 remove"
                                    title="Remove"
                                    onClick={() => {
                                      if(!expenses[expenseIndex]?.expense_approved_amount){
                                        expenseRemove(expenseIndex)
                                      }
                                    }}
                                  >
                                    <i className="fa-regular fa-trash-can" />
                                  </Link>
                                  )
                                }
                                
                              </td>
                            </tr>
                            <tr>
                              <td colSpan={6}>
                                <AttachmentThumb
                                  fields={
                                    expenses &&
                                    expenses[expenseIndex]?.attachments
                                  }
                                  remove={(itemIndex) =>{
                                    if(!expenses[expenseIndex]?.expense_approved_amount){
                                      removeAttachment(expenseIndex, itemIndex)
                                    }else{
                                      toast.error("You cannot remove attachments after approval")
                                    }
                                  }
                                  }
                                />
                              </td>
                            </tr>
                          </>
                        ))}
                      </tbody>
                    </table>


                  </div>
                </div>
                {/*
                 */}
              </div>
                 }
                 
                                     {/* ✅ Total Section at Bottom */}
                    {/* ✅ Total Section at Bottom */}
                    <div className="  bg-light p-3 border-top d-flex align-items-end justify-content-end">
                      <div className="  ">
                        <h5 className="fw-bold">Total Expense:</h5>
                      </div>
                      <div className=" col-md-1  d-flex justify-content-end">
                        <h5 className="fw-bold"> {totals?.expense_amount?.toFixed(2)}</h5>
                      </div>
                    </div>
                    <div className="  bg-light p-3 border-top d-flex align-items-end justify-content-end">
                      <div className=" ">
                        <h5 className="fw-bold">Approved:</h5>
                      </div>
                      <div className=" col-md-1 d-flex justify-content-end">
                        <h5 className="fw-bold">
                          {" "}
                          {totals?.expense_approved_amount?.toFixed(2)}
                        </h5>
                      </div>
                    </div>
                 
              

              <div className="row">
                <div className="col-md-6 col-sm-12">
                  <div className="input-block mb-3">
                    <label className="col-form-label">
                      Attachments{" "}
                      {uploadLoading && <i class="fa fa-spinner fa-spin"></i>}
                    </label>
                    <div
                      {...getRootProps({ className: 'dropzone' })}
                      style={{
                        border: '2px dashed #000',
                        padding: '20px',
                        textAlign: 'center',
                      }}
                    >
                      <input {...getInputProps()} disabled={
                        uploadLoading ||
                        (selectedExpense &&
                          selectedExpense?.approval_status !== "pending")
                      } />
                      <p>Drag & Drop your files here, or click to select files</p>
                    </div>

                    {/* <input
                      type="file"

                      className="form-control"
                      id="cv_upload"
                      // accept=".png, .jpg, .jpeg"
                      onChange={fileUploadHandler}
                      disabled={
                        uploadLoading ||
                        (selectedExpense &&
                          selectedExpense?.approval_status !== "pending")
                      }
                      multiple
                    /> */}
                    <p className="text-danger mb-2">
                      {errors?.attachments?.message}
                    </p>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="input-block mb-3  col-md-6 col-sm-12">
                  <label className="col-form-label mt-4">Attachments</label>
                  <Attachments fields={fields} remove={remove} />
                </div>
              </div>

              <div className="submit-section">
                <Button
                  loading={loading}
                  disabled={
                    loading ||
                    uploadLoading ||
                    (selectedExpense &&
                      selectedExpense?.approval_status !== "pending")
                  }
                  className="btn btn-primary submit-btn"
                  type="submit"
                  label="Submit"
                />
              </div>
            </form>
            {/* )} */}
          </div>
        </div>
      </EssFullWidthModal>
    </>
  );
};

export default ExpenseCreateModal;
